import { render } from "./UploadPage.vue?vue&type=template&id=16c6af59&scoped=true&ts=true"
import script from "./UploadPage.vue?vue&type=script&lang=ts"
export * from "./UploadPage.vue?vue&type=script&lang=ts"

import "./UploadPage.vue?vue&type=style&index=0&id=16c6af59&scoped=true&lang=css"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16c6af59"]])

export default __exports__